export default "__VITE_ASSET__6352d68b__"